<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <div class="req-form">
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule" :label-width="70" label-position="right">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷名称">
            <Input v-model="volumeData.name" :disabled="true" style="width: 300px" />
          </FormItem>
          <FormItem prop="image_name" label="镜像名称">
            <Input v-model="reqForm.image_name" :maxlength="255" style="width: 300px"/>
          </FormItem>
          <FormItem prop="disk_format" label="镜像格式">
            <Select v-model="reqForm.disk_format"  style="width: 300px" transfer>
              <Option v-for="item in imageFormatList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <!--<FormItem prop="visibility" label="可见性">-->
            <!--<RadioGroup v-model="reqForm.visibility" type="button">-->
              <!--<Radio label="public">公有</Radio>-->
              <!--<Radio label="private">私有</Radio>-->
            <!--</RadioGroup>-->
          <!--</FormItem>-->
          <!--<FormItem prop="protected" label="受保护的">-->
            <!--<i-switch v-model="reqForm.protected">-->
              <!--<span slot="open">是</span>-->
              <!--<span slot="close">否</span>-->
            <!--</i-switch>-->
          <!--</FormItem>-->
          <FormItem prop="force" label="强制" v-if="current_status === 'in-use'">
            <i-switch v-model="reqForm.force">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
export default {
  name: 'volume-upload-image',
  data () {
    return {
      title: '上传卷到镜像',
      volumeData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        image_name: '',
        disk_format: 'raw',
        force: false,
        visibility: 'private',
        protected: false
      },
      reqRule: {
        image_name: [
          { required: true, message: '请填写镜像名称', trigger: 'blur' }
        ],
        disk_format: [
          { required: true, message: '请选择镜像格式', trigger: 'change' }
        ]
      },
      imageFormatList: [
        {value: 'qcow2', label: 'qcow2 - QEMU模拟器'},
        {value: 'raw', label: 'raw'},
        {value: 'vdi', label: 'vdi - VirtualBox虚拟磁盘镜像'},
        {value: 'vmdk', label: 'vmdk - Vmware虚拟机磁盘'},
        {value: 'vhd', label: 'vhd - Vmware虚拟硬盘'},
        {value: 'vhdx', label: 'vhdx - 大型虚拟硬盘'}
      ],
      current_status: '',
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id, status) {
      this.current_status = status
      detailPrivateCloudVolume(id).then(res => {
        this.volumeData = res.data.volume
        this.modalShow = true
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'os-volume_upload_image': this.reqForm
          }
          this.submitting = true
          actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
